import styled from 'styled-components';
import { color } from '~/assets/styles/colors';
import { Button } from 'reactstrap';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${color.primary};
  border-bottom-left-radius: 28px;
  border-bottom-right-radius: 28px;
`;

export const FilterAndDown = styled.div`
	display: flex;
	justify-content: right;
	margin-bottom: 10px;
`;

export const TextClick = styled.div`
	color: ${color.blue};
	cursor: pointer;
	margin-right: 20px;
	font-size: 16px;
`;

export const DivMontante = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

export const DivView = styled.div`
	display: flex;
	width: 60%;
	flex-direction: row;
	justify-content: space-between;
`;

export const ImgMontante = styled.img`
	filter: brightness(0);
`;

export const TextMontante = styled.div``;

export const ButtonStyle = styled(Button)`
	//float: right;

	//width: 100%;
	background-color: ${color.yellow};
	border-radius: 15px;
	color: ${color.black};
	border-color: transparent;
`;
